import { render, staticRenderFns } from "./company_list.vue?vue&type=template&id=61fa8ee2&scoped=true&"
import script from "./company_list.vue?vue&type=script&lang=js&"
export * from "./company_list.vue?vue&type=script&lang=js&"
import style0 from "./company_list.vue?vue&type=style&index=0&id=61fa8ee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa8ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fa8ee2')) {
      api.createRecord('61fa8ee2', component.options)
    } else {
      api.reload('61fa8ee2', component.options)
    }
    module.hot.accept("./company_list.vue?vue&type=template&id=61fa8ee2&scoped=true&", function () {
      api.rerender('61fa8ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPool/channelPoolDetails/form/company_list.vue"
export default component.exports